import { Component, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantUserService } from 'app/services';
import { MerchantUserSuspendTypeEnum } from 'app/models';
import { Utils } from 'app/utils';

@Component({
    selector: 'partner-suspend-employee',
    templateUrl: './partner-suspend-employee.component.html',
    styleUrls: ['./partner-suspend-employee.component.scss',
        '../../../../../styles/style-layout.scss']
})
export class PartnerSuspendEmployeeComponent {
    constructor(
        private messageService: MessageService,
        private merchantUserService: MerchantUserService) {
    }

    @Input()
    public showSuspendEmployee: boolean = false;

    @Input()
    public merchantUser: any = {};

    @Input()
    public onHide: () => void = () => { };
    public loading: boolean = false;

    public suspendType = MerchantUserSuspendTypeEnum;
    public suspendReason: string = '';

    public employeeIsSuspended: boolean = false;

    public selectedSuspendType: MerchantUserSuspendTypeEnum | null = null;

    public suspendMerchantUser() {
        const dto = {
            MerchantUserId: this.merchantUser.UserId,
            SuspendType: this.selectedSuspendType,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            SuspendReason: this.suspendReason
        };
        this.loading = true;
        this.merchantUserService.suspendUser(dto, this.messageService)
            .then(data => {
                this.loading = false;

                if (!data) {
                    return;
                }

                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.employeeIsSuspended = true;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    public handleHideSuspendUserDialog() {
        this.onHide();
    }
}
